module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAJlJREFUGBmFUEEKAkEMSwafJHgSfMB+xeNeBD2JF49+ZR8g7EnwTROb3VlhhhV7KKRN0zZEieNr2GeoJ7h1SdA7gffHrhuN6RSkUwaukCbsmoNEjsFzkG+0Ukw/JaS5XedCPmy8LvaskjxiAVF9Wm6qdWpkzk+lmoqQje/aYosnB2yBD26bC3bPnDT7xMsauXxse8avb/8M/wDkJTzt8sHW0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/star.png
// module id = F344
// module chunks = 1